import store from '@/store/index';
import dayjs from 'dayjs';
import { getAuthorApps } from '@/services/authorBackendTool';
import api from './api';

// 僅在AuthorDataCenterView和AuthorTool混入
// 取得是否顯示tabs的資料的function
export default {
  data() {
    return {
      adminAppId: 2, // CMoney官方 AppId
    };
  },
  computed: {
    forumIds() {
      return store.getters.forumIds;
    },

    appList() {
      return store.getters.appList;
    },

    appListWithAppLink() {
      return store.getters.appListWithAppLink;
    },

    pcList() {
      return store.getters.pcList;
    },

    isGetTabsData() {
      return store.getters.isGetTabsData;
    },

    nowTime() {
      return dayjs().format('YYYY/MM/DD HH:mm');
    },
  },
  methods: {
    // 取作者同學會memberId和groupId
    async getAuthorForumIds() {
      if (store.getters.isGetTabsData.forumIds) return;
      try {
        const formData = new FormData();
        formData.append('action', 'getauthorforumids');

        const data = await api.methods.request(formData);
        if (data !== false && data.data) {
          const ids = data.data[0];
          if (ids.length) {
            const forumIds = {
              memberId: ids[0],
              userId: ids[1],
              groupId: ids[2],
            };
            this.updateForumIds(forumIds);
          }
        }
        this.updateIsGetTabsData('forumIds', true);
      } catch (error) {
        console.log(error);
      }
    },

    // 取得app清單
    async getAppList() {
      if (store.getters.isGetTabsData.appList) return;
      // router guard 是以 tabsData.methods.getAppList() 裸呼叫，this 不是元件實例，memberId 一律取自 store
      const memberId = store.getters.memberInfo.m;
      // 還沒取得會員資料時不打（也不設旗標），交由 AuthorDataCenterView 的 memberId watcher 補抓
      if (!memberId) return;
      try {
        const data = await getAuthorApps(memberId);
        this.updateAppList(data.appList || []);
        this.updateIsGetTabsData('appList', true);
      } catch (error) {
        console.log(error);
      }
    },

    // 取得可使用appLink功能的app清單
    async getAppListWithAppLink() {
      if (store.getters.isGetTabsData.appListWithAppLink || !this.memberId) return;
      try {
        const formData = new FormData();
        formData.append('action', 'getauthordynamiclinkappids');
        formData.append('authorMemberId', this.memberId);

        const data = await api.methods.request(formData);
        if (data !== false) {
          this.updateAppListWithAppLink(data.appList);
          this.updateIsGetTabsData('appListWithAppLink', true);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getPcList() {
      if (store.getters.isGetTabsData.pcList) return;
      try {
        const formData = new FormData();
        formData.append('action', 'getauthorpcids');

        const data = await api.methods.request(formData);
        if (data !== false) {
          this.updatePcList(data.pcList);
          this.updateIsGetTabsData('pcList', true);
        }
      } catch (error) {
        console.log(error);
      }
    },

    updateForumIds(forumIds) {
      store.dispatch('updateForumIds', {
        forumIds,
      });
    },

    updateAppList(appList) {
      store.dispatch('updateAppList', {
        appList,
      });
    },

    updatePcList(pcList) {
      store.dispatch('updatePcList', {
        pcList,
      });
    },

    updateAppListWithAppLink(appListWithAppLink) {
      store.dispatch('updateAppListWithAppLink', {
        appListWithAppLink,
      });
    },

    updateIsGetTabsData(option, data) {
      store.dispatch('updateIsGetTabsData', {
        option,
        data,
      });
    },
  },
};
